import * as yup from "yup";
const FileSize = 15000000;
const allowedFormats = [
    "image/jpeg",
    "image/png",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const masterResourceTableData = [
    {
        activity: "abc",
        name: "xyz",
        kind: "bbb",
        unit: "12",
    },
    {
        activity: "abc",
        name: "xyz",
        kind: "bbb",
        unit: "12",
    },
    {
        activity: "abc",
        name: "xyz",
        kind: "bbb",
        unit: "12",
    },
    {
        activity: "abc",
        name: "xyz",
        kind: "bbb",
        unit: "12",
    },
    {
        activity: "abc",
        name: "xyz",
        kind: "bbb",
        unit: "12",
    },
];


export const EventResourceConfig = [
    {
        id: 0,
        name: "",
        heading: "",
        fields: [
            {
                name: "incidentname",
                label: "incidentresourceformlabels.incidentname",
                type: "select",
                options: [],

            },
            {
                name: "eventdatetime",
                label: "incidentresourceformlabels.eventdatetime",
                type: "datetime",
                maxDate: new Date().toISOString().slice(0, 16)
            },
            {
                name: "latitude",
                label: "facilityformlabels.latitude",
                type: "input",
                disabled: true,
                col: 3

            },
            {
                name: "longitude",
                label: "facilityformlabels.longitude",
                type: "input",
                disabled: true,
                col: 3
            },


            {
                name: "eventDes",
                label: "incidentresourceformlabels.eventdes",
                type: "text_area",
                width: '50%'
            },
            {
                name: "uploafile",
                label: "incidentresourceformlabels.uploadfile",
                type: "multi_file_upload",

                //type: "input",

            },
        ],
    },
];

export const eventresourceschema = [
    yup.object({
        // incidentname: yup.string().required("Please Enter Incident Name"),
        // incidentcategory: yup.string().required("Please select Incident Category"),
        eventdatetime: yup
            .string()
            .test(
                'is-not-future',
                'Event date/time cannot be in the future',
                (value) => {
                    if (!value) return false;
                    const selectedDate = new Date(value);
                    const now = new Date();
                    return selectedDate <= now; // Only allow past/current time
                }
            ),
        eventDes: yup
            .string()
            .max(250, 'Event description must be at most 250 characters'),


    }),
];

export const evetnresourcecolumnsForExport = [
    { label: "Incident Name", key: "incidentname" },
    { label: "Latitude", key: "latitude" },
    { label: "Longitude", key: "longitude" },
    { label: "Event Date & Time", key: "eventdatetime" },
    { label: "Event Des", key: "eventDes" },
    // {label: "Image", key: "resource_image_name"},
    { label: "uploafile", key: "uploafile" },
];
